/*!
 * STRYDE Recent Sales Popup
 * Self-contained. No jQuery. No external dependencies.
 * All logic namespaced under STRYDERecentSalesPopup.
 */
(function () {
  'use strict';

  /* ─── Bail early for reduced-motion preference ─── */
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  /* ─── Main object ─── */
  var STRYDERecentSalesPopup = {
    el: null,
    items: [],
    currentIndex: 0,
    settings: {},
    _timers: [],

    /* ── Initialise ── */
    init: function () {
      this.el = document.getElementById('stryde-recent-sales-popup');
      if (!this.el) return;

      /* Read settings from data attributes set by Liquid */
      this.settings = {
        delay:        parseInt(this.el.dataset.delay, 10)    || 8,
        duration:     parseInt(this.el.dataset.duration, 10) || 6,
        interval:     parseInt(this.el.dataset.interval, 10) || 25,
        position:     this.el.dataset.position               || 'bottom-left',
        heading:      this.el.dataset.heading                || 'Someone recently purchased',
        sessionClose: this.el.dataset.sessionClose === 'true',
      };

      /* Skip if visitor already closed the popup this session */
      if (
        this.settings.sessionClose &&
        sessionStorage.getItem('stryde_popup_closed') === '1'
      ) {
        return;
      }

      /* Parse product data from the embedded JSON script tag */
      var dataEl = document.getElementById('stryde-recent-sales-data');
      if (!dataEl) return;

      try {
        this.items = JSON.parse(dataEl.textContent || dataEl.innerHTML);
      } catch (e) {
        return;
      }

      if (!this.items || !this.items.length) return;

      /* Apply desktop position class */
      this.el.classList.add('stryde-recent-sales-popup--' + this.settings.position);

      /* Wire up close button */
      var closeBtn = this.el.querySelector('.stryde-recent-sales-popup__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this._onClose.bind(this));
      }

      /* Shuffle items so rotation order varies between page loads */
      this._shuffle(this.items);

      /* Kick off the first popup after the initial delay */
      this._schedule(this.settings.delay * 1000);
    },

    /* ── Check whether the cart drawer is currently open ── */
    _isCartDrawerOpen: function () {
      /*
       * Dawn cart drawer adds overflow-hidden to <body> when open.
       * Also check for the cart-drawer custom element having an 'active' class
       * as a belt-and-braces fallback.
       */
      if (document.body.classList.contains('overflow-hidden')) return true;

      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active')) return true;

      return false;
    },

    /* ── Schedule the next show attempt after `delay` ms ── */
    _schedule: function (delay) {
      var self = this;
      var t = setTimeout(function () {
        /*
         * If the cart drawer is open, hold off and retry in 5 seconds
         * so the popup never overlaps an active cart interaction.
         */
        if (self._isCartDrawerOpen()) {
          self._schedule(5000);
          return;
        }
        self._showItem();
      }, delay);
      this._timers.push(t);
    },

    /* ── Show the next product item ── */
    _showItem: function () {
      var item = this.items[this.currentIndex % this.items.length];
      this.currentIndex++;

      /* Update DOM content */
      var headingEl = this.el.querySelector('.stryde-recent-sales-popup__heading');
      var productEl = this.el.querySelector('.stryde-recent-sales-popup__product');
      var imgEl     = this.el.querySelector('.stryde-recent-sales-popup__image');
      var linkEl    = this.el.querySelector('.stryde-recent-sales-popup__link');

      if (headingEl) headingEl.textContent = this.settings.heading;
      if (productEl) productEl.textContent = item.title || '';

      if (linkEl) {
        var url = item.url && item.url !== '#' ? item.url : null;
        if (url) {
          linkEl.href = url;
          linkEl.removeAttribute('tabindex');
          linkEl.removeAttribute('aria-hidden');
          linkEl.classList.remove('stryde-recent-sales-popup__link--no-url');
        } else {
          /* No real URL: disable the link so it does not scroll to top */
          linkEl.removeAttribute('href');
          linkEl.setAttribute('tabindex', '-1');
          linkEl.setAttribute('aria-hidden', 'true');
          linkEl.classList.add('stryde-recent-sales-popup__link--no-url');
        }
      }

      if (imgEl) {
        if (item.image) {
          imgEl.src = item.image;
          imgEl.alt = item.title || '';
          imgEl.removeAttribute('hidden');
        } else {
          imgEl.setAttribute('hidden', '');
        }
      }

      /* Make popup visible */
      this.el.removeAttribute('aria-hidden');
      this.el.classList.add('stryde-recent-sales-popup--visible');

      /* Auto-hide after visible duration, then queue the next item */
      var self = this;
      var t = setTimeout(function () {
        self._hide();
        self._schedule(self.settings.interval * 1000);
      }, this.settings.duration * 1000);
      this._timers.push(t);
    },

    /* ── Hide the popup without clearing the rotation schedule ── */
    _hide: function () {
      this.el.setAttribute('aria-hidden', 'true');
      this.el.classList.remove('stryde-recent-sales-popup--visible');

      /* Remove link from tab order while hidden */
      var linkEl = this.el.querySelector('.stryde-recent-sales-popup__link');
      if (linkEl) {
        linkEl.setAttribute('tabindex', '-1');
        linkEl.setAttribute('aria-hidden', 'true');
      }
    },

    /* ── User clicked close: hide and stop rotation for this session ── */
    _onClose: function () {
      this._hide();
      this._clearTimers();

      if (this.settings.sessionClose) {
        sessionStorage.setItem('stryde_popup_closed', '1');
      }
    },

    /* ── Cancel all pending timers ── */
    _clearTimers: function () {
      this._timers.forEach(function (t) { clearTimeout(t); });
      this._timers = [];
    },

    /* ── Fisher-Yates shuffle (in-place) ── */
    _shuffle: function (arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
    },
  };

  /* ─── Bootstrap after DOM is ready ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      STRYDERecentSalesPopup.init();
    });
  } else {
    STRYDERecentSalesPopup.init();
  }

})();
